import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_VERTICAL_SIGNING } from "../../../../../common/constants/modules"

import { verticalSigningQueryKeys } from "./queryKeys"
import { useVerticalSigningQuery } from "./useVerticalSigningQuery"


export function useVerticalSigningCategoriesStats(parameters = {}, config = {}) {
    const url = "vertical_signs/stats/vertical_sign_types/"

    const queryParameters = useExtendWithSubnetworks(parameters, API_MODULE_VERTICAL_SIGNING)

    const queryKey = verticalSigningQueryKeys["stats_categories"](queryParameters)

    return useVerticalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            ...config,
        },
    )
}